/* release sync touch: referral popup */
(() => {
  const config = document.querySelector('[data-referral-popup-config]');
  if (!config) return;
  const COOKIE_NAME = 'mana_referral_popup_intent';
  const DISPLAYED_COOKIE_NAME = 'mana_referral_popup_displayed';
  const COOKIE_DIALOG_SELECTOR = '#cookie-consent-dialogBox, #pandectes-banner';
  const referralPath = config.dataset.referralPath || '/pages/referrals';
  const loginPath = config.dataset.loginPath || '/account/login';
  const customerLoggedIn = config.dataset.customerLoggedIn === 'true';
  const programMember = config.dataset.programMember === 'true';
  const onReferralPage = config.dataset.onReferralPage === 'true';
  const readIntent = () => {
    const prefix = `${COOKIE_NAME}=`;
    const cookie = document.cookie.split('; ').find((item) => item.startsWith(prefix));
    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : '';
  };
  const wasPopupDisplayed = () => document.cookie
    .split('; ')
    .some((item) => item === `${DISPLAYED_COOKIE_NAME}=1`);
  const rememberPopupWasDisplayed = () => {
    document.cookie = `${DISPLAYED_COOKIE_NAME}=1; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
  };
  const saveIntent = (intent) => { document.cookie = `${COOKIE_NAME}=${encodeURIComponent(intent)}; Path=/; Max-Age=900; SameSite=Lax; Secure`; };
  const clearIntent = () => { document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax; Secure`; };
  const redirectForIntent = (intent) => {
    saveIntent(intent);
    if (customerLoggedIn) return window.location.assign(referralPath);
    const loginUrl = new URL(loginPath, window.location.origin);
    loginUrl.searchParams.set('return_url', referralPath);
    window.location.assign(loginUrl.toString());
  };
  const openPendingReferralAction = () => {
    const intent = readIntent();
    if (!customerLoggedIn || !intent) return;
    if (!onReferralPage) return window.location.replace(referralPath);
    clearIntent();
    if (intent !== 'qr' || !programMember) return;
    let opened = false;
    const openQr = () => {
      if (opened || document.documentElement.dataset.manaReferralReady !== 'true') return;
      const qrButton = document.querySelector('[data-referral-action="qr"]');
      if (!qrButton) return;
      opened = true;
      qrButton.click();
    };
    document.addEventListener('mana:referral-ready', openQr, { once: true });
    window.setTimeout(openQr, 1200);
  };
  const initPopup = () => {
    openPendingReferralAction();
    const popup = document.querySelector('[data-referral-popup]');
    if (!popup || wasPopupDisplayed()) return;
    const hide = () => {
      rememberPopupWasDisplayed();
      popup.classList.add('is-hiding');
      popup.classList.remove('is-visible');
      window.setTimeout(() => { popup.hidden = true; popup.classList.remove('is-hiding'); }, 700);
    };
    popup.querySelector('[data-referral-popup-close]')?.addEventListener('click', hide);
    popup.querySelectorAll('[data-referral-popup-action]').forEach((button) => {
      button.addEventListener('click', () => {
        rememberPopupWasDisplayed();
        redirectForIntent(button.dataset.referralPopupAction);
      });
    });
    let popupScheduled = false;
    let popupTimer;
    let cookieDialogObserver;

    const showPopup = () => {
      popup.hidden = false;
      window.requestAnimationFrame(() => popup.classList.add('is-visible'));
    };

    const evaluateCookieDialog = () => {
      const cookieDialog = document.querySelector(COOKIE_DIALOG_SELECTOR);
      const cookieDialogIsVisible = cookieDialog && window.getComputedStyle(cookieDialog).display !== 'none';

      if (cookieDialogIsVisible) {
        window.clearTimeout(popupTimer);
        popupScheduled = false;
        return;
      }

      if (!cookieDialog && document.readyState !== 'complete') return;

      if (popupScheduled) return;

      popupScheduled = true;
      popupTimer = window.setTimeout(() => {
        const currentCookieDialog = document.querySelector(COOKIE_DIALOG_SELECTOR);
        const currentCookieDialogIsVisible = currentCookieDialog
          && window.getComputedStyle(currentCookieDialog).display !== 'none';

        popupScheduled = false;
        if (currentCookieDialogIsVisible) return;

        cookieDialogObserver?.disconnect();
        showPopup();
      }, 2000);
    };

    cookieDialogObserver = new MutationObserver(evaluateCookieDialog);
    cookieDialogObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true,
    });
    evaluateCookieDialog();
    window.addEventListener('load', evaluateCookieDialog, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPopup, { once: true });
  else initPopup();
})();
